import { exists } from '../generals'

export type SortValue<ColumnKey extends string> = {
  columnKey: ColumnKey
  ascending: boolean
}

export const getSortIconBySortValue = <ColumnKey extends string>(
  sortValue: SortValue<ColumnKey> | null,
  columnKey: ColumnKey,
): 'blank' | 'sort-asc' | 'sort-desc' =>
  exists(sortValue) && sortValue.columnKey === columnKey
    ? sortValue.ascending
      ? 'sort-asc'
      : 'sort-desc'
    : 'blank'
